import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './node.types';
import * as constants from './node.constants';

export const nodeReducer = generateResourceReducer<types.IOrganizationChartNode>({
  STORE: constants.STORE_NODE,
  CLEAR: constants.CLEAR_NODE,
});
